import axios from 'axios';
import { buildUrl } from './buildUrl.js';

const axiosInstance = axios.create({ timeout: 30_000 });

const handleError = async error => {
  const { config, response } = error;
  const { status } = response;
  const { method, url } = config;

  const failureReason =
    response?.data?.error ||
    response?.data?.message ||
    error.message ||
    'unknown error';

  // following the original pattern of logging analytics
  if (400 <= status && 'object' === typeof analyticsIntegrations) {
    if (['POST', 'PUT'].includes(method)) {
      analyticsIntegrations.formFail(url, failureReason);
    } else if ('GET' === method) {
      analyticsIntegrations.requestFail(url, failureReason);
    }
  }

  return {
    error: new Error(failureReason),
    status
  };
};

// Attach error handler to axios instance
axiosInstance.interceptors.response.use(
  response => response,
  handleError
);

const httpRequest = async ({
  method,
  endpoint,
  body,
  params,
  query,
  options
}) => {
  const url = await buildUrl(endpoint, params, query);

  const config = {
    method,
    url,
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-store'
    }
  };

  if (body) {
    config.data = body;
  }

  if (options.useAccessToken) {
    const token = window.PSSessions.Cookies('PSAccess');
    config.headers.Authorization = `Bearer ${token}`;
  }

  return axiosInstance.request(config);
};

export { httpRequest };
